<div class="text-center py-3" *ngIf="loading">
  <i class="fas fa-spinner fa-pulse fa-2x"></i>
</div>
<div *ngIf="!loading">
  <table class="table table-sm" style="font-size: 93%">
    <tbody>
      <tr>
        <th scope="row" style="width: 30%; border: none !important">Created on:&nbsp;</th>
        <td style="border: none !important">{{ matter_details.created_at }}</td>
      </tr>
      <tr>
        <th scope="row" style="width: 30%; border: none !important">Created by:&nbsp;</th>
        <td style="border: none !important">{{ matter_details.created_by }}</td>
      </tr>
      <tr>
        <th scope="row" style="width: 30%; border: none !important">Opener:&nbsp;</th>
        <td style="border: none !important">{{ matter_details.opener }}</td>
      </tr>
      <tr>
        <th scope="row" style="width: 30%; border: none !important">Rate Type:&nbsp;</th>
        <td style="border: none !important">{{ matter_details.rate_type }}</td>
      </tr>
    </tbody>
  </table>
  <div class="row my-2">
    <div class="col-12 px-4">
      <a href="javascript: void(0)" class="btn btn-link btn-sm" (click)="showNewDetailForm = !showNewDetailForm"> <i [class]="'fa fa-' + (showNewDetailForm ? 'minus' : 'plus') + '-circle'"></i>&nbsp;New Detail </a>
      <app-matter-detail-form *ngIf="showNewDetailForm" [matter_id]="matter_id" (formResult)="formResult($event)"></app-matter-detail-form>
    </div>
  </div>
  <table class="table table-sm" style="font-size: 82%">
    <tbody [appNativeSortableJs]="details" [sortableOptions]="sortOptions">
      <tr *ngFor="let detail of details">
        <td *ngIf="!detail.editing" style="width: 28.5%">
          <span class="draggable-elem"><i class="fas fa-random"></i></span>
          <button title="Edit detail" [disabled]="detail.deleting" (click)="editDetail(detail)" tooltip="Edit matter date" type="button" style="cursor: pointer" class="btn btn-outline-primary btn-sm"><i class="fas fa-pencil-alt"></i></button>
          <button title="Remove detail" (click)="confirmDetailDelete(detail, deleteModal)" [disabled]="detail.deleting" tooltip="Remove detail" type="button" style="cursor: pointer" class="btn btn-outline-danger btn-sm"><i class="fas fa-minus-circle"></i></button>
        </td>
        <td *ngIf="!detail.editing" style="width: 40%">{{ detail.detail_type_name }}</td>
        <td *ngIf="!detail.editing" style="width: 29%" [innerHTML]="detail.value | safeHtml"></td>
        <td colspan="3" *ngIf="detail.editing">
          <div class="font-italic mb-2 text-info">Editing Detail</div>
          <div class="row">
            <div class="col-12 px-4">
              <app-matter-detail-form [detail_id]="detail.id" (formResult)="formResult($event, detail)"></app-matter-detail-form>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #deleteModal let-c="close" let-d="dismiss">
  <!--<div class="modal-header">
    	<h4 class="modal-title">Modal title</h4>
    	<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
    		<span aria-hidden="true">&times;</span>
    	</button>
  	</div>-->
  <div class="modal-body">
    <p>
      Remove detail - <em>{{ detailToBeDeleted ? detailToBeDeleted.detail_type_name : '' }}</em> <span [innerHTML]="detailToBeDeleted ? (detailToBeDeleted.value | safeHtml) : ''"></span> ?
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="c('Delete')">Confirm delete</button>
    <button type="button" class="btn btn-secondary" (click)="d('Cancel')">Cancel</button>
  </div>
</ng-template>
